import { render } from "./SidebarMenu.vue?vue&type=template&id=123993bc&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=123993bc&scoped=true&lang=css"
import "./SidebarMenu.vue?vue&type=style&index=1&id=123993bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123993bc"]])

export default __exports__